import stepNavigation from './step-navigation.component';
angular.module('BBPublicBooking').component('bbStepNavigation', stepNavigation);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/step-navigation/step-navigation.module.js